import { ApiError } from './query-client';

interface ApiOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: unknown;
  signal?: AbortSignal;
}

// Wrapper fetch tipado: paths relativos ("/api/...") — en dev los resuelve
// el proxy de Vite, en prod el mismo origin (Express sirve frontend/dist).
// credentials:'include' manda la cookie de sesión. Convención de error del
// backend: body JSON { error: string }.
export async function api<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const { method = 'GET', body, signal } = options;

  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    signal,
  });

  if (!res.ok) {
    let parsedBody: unknown = null;
    try {
      parsedBody = await res.json();
    } catch {
      // sin body JSON: se pierde en silencio, no es crítico para el manejo de errores
    }
    const message =
      parsedBody && typeof parsedBody === 'object' && 'error' in parsedBody
        ? String((parsedBody as { error: unknown }).error)
        : `${method} ${path} → HTTP ${res.status}`;
    throw new ApiError(res.status, message, parsedBody);
  }

  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
